
/**
 * @description 儿童节分享链接页面
 * @returns /front/activities/childrensDay/share
*/
import React, { useState } from "react";
import gotoBrowserImg from 'images/goto-browser.png';
import Library from 'library';
import styles from './styles.module.scss';

const appSchema = 'gktapp://com.gkewang';

export default () => {
    // 获取链接携带参数
    const params = Library.Util.url.paramsToObj();

    const [maskShow, setMaskShow] = useState(false);
    const targetUrl = `${process.env.REACT_APP_GKT_LINK}/front/activities/childrensDay?${Library.Util.url.objectToQueryParams(params)}`;

    const launchUrl = `${appSchema}/screen/CustomWeb?uri=${encodeURIComponent(targetUrl)}`;

    const openApp = () => {
        if (Library.Platform.check.isWechat()) {
            setMaskShow(true);
        } else {
            window.location.href = launchUrl;
            setTimeout(() => {
                window.location.href = Library.Util.ORIGIN_DOWNLOAD_URL;
            }, 3000);

        }
    }

    return (
        <div className={styles.share_download_app_page}>
            <img src={require('images/childrensDay/childrensDay-land-page.png')} alt="" />
            <div className={styles.download_btn} onClick={() => openApp()}></div>
            {
                maskShow && 
                <div className={styles.mask} onClick={() => setMaskShow(false)}>
                    <img src={gotoBrowserImg} alt="" />
                </div>
            }
        </div>
    )
}